<section class="flex flex-col gap-32">
  <div class="flex flex-col">
    <app-section-header
      title="Sapec Software offers a complete list of professional IT Services"
      description="
        Core services include Business Analysis, UX/UI Design, Front-End Development, Back-End Development, Cloud Infrastructure, and QA Testing.Get everything you need for full-cycle software development for your web or mobile application.
      "
      containerClassName="pt-0"
      className="max-w-[800px]"/>

    <div class="flex w-full flex-col items-center justify-center gap-3 lg:flex-row">
      <div class="relative w-full max-w-[380px]">
        <input
          hlmInput
          type="text"
          placeholder="Search"
          class="w-full rounded-xl pl-10 !text-base"
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearch($event)"/>
        <lucide-icon name="search" size="20"
                     class="absolute left-1.5 top-1/2 -translate-y-1/2 text-tertiary-foreground"/>
      </div>
      <button hlmBtn variant="outline" class="rounded-xl" (click)="clearSearch()">Clear</button>
    </div>

    <div class="flex flex-col gap-10">
      @if (!loading()) {
        @if (services().length >= 1) {
          <div class="flex flex-wrap justify-center gap-3 pt-6">
            @for (service of services(); track service) {
              <a
                class="flex cursor-pointer items-center justify-center gap-2 rounded-3xl border border-gray-200 bg-transparent px-4 py-2 hover:bg-gray-50 focus-visible:ring-gray-100">
                <span class="text-base">{{ service.name }}</span>
                <lucide-icon name="arrow-up-right" size="20"/>
              </a>
            }
          </div>
        } @else {
          <div class="w-full pt-10 text-center text-2xl font-semibold">No such services</div>
        }
      } @else {
        <div class="flex flex-wrap justify-center gap-3 pt-6">
          @for (item of skeletonPlaceholders; track item) {
            <hlm-skeleton class="h-10 rounded-3xl" [ngClass]="item.widthClass"></hlm-skeleton>
          }
        </div>
      }
      <div class="text-center text-lg font-normal">
        Don’t see the service you need? Reach out to us at
        <span class="cursor-pointer underline hover:text-primary">info&#64;sapec.md</span>, and let us know more about
        your industry and
        what you need help with.
      </div>
    </div>
  </div>

  <div class="flex flex-col gap-8">
    <app-section-header
      [title]="'Services That Empower and Promote Accessibility in Design and Functionality'"
      [description]="
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis.'
      "
      containerClassName="pt-0"
      className="max-w-[800px]"/>

    <div class="grid grid-cols-1 gap-8 lg:grid-cols-2">
      @for (project of projects; track project) {
        <div class="flex flex-col">
          <div class="flex h-full flex-col gap-3 rounded-3xl bg-gray-100 p-6 lg:items-start">
            <span class="text-2xl font-medium">{{ project.title }}</span>
            <div class="flex flex-wrap gap-1">
              @for (badge of project.badges; track badge) {
                <span class="rounded-3xl border border-gray-200 bg-background px-2 py-1 text-xs">{{ badge }}</span>
              }
            </div>
          </div>
          <div class="flex h-full flex-col gap-3 rounded-3xl bg-gray-100 p-6 font-medium lg:items-start">
            <span class="text-xl">{{ project.challenge.title }}</span>
            <span class="text-lg">{{ project.challenge.description }}</span>
          </div>

          <div class="flex h-full flex-col gap-4 rounded-3xl bg-gray-100 p-6 font-medium lg:items-start">
            <div class="flex flex-col gap-2 border-b border-gray-200 pb-3">
              <span class="text-lg">{{ project.solution.title }}</span>
              <span class="text-base font-normal text-tertiary-foreground">{{ project.solution.description }}</span>
            </div>

            <div class="flex flex-col">
              <span class="text-lg">{{ project.outcome.title }}</span>
              <span class="text-base font-normal text-tertiary-foreground">{{ project.outcome.description }}</span>
            </div>
          </div>
          <div class="flex h-full rounded-3xl bg-gray-100 p-6 font-medium lg:items-start">
            <button hlmBtn variant="contrast" class="w-fit rounded-xl" (click)="goToProject(project)">View Case</button>
          </div>
        </div>
      }
    </div>

    <div class="flex justify-center pt-3">
      <button hlmBtn variant="secondary" class="w-fit rounded-xl">View All</button>
    </div>
  </div>

  <div class="flex flex-col">
    <app-section-header
      [title]="'Why you Should Choose Sapec Software'"
      [description]="
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent '
      "
      containerClassName="pt-0"
      className="max-w-[800px]"/>

    <div class="flex flex-wrap justify-center gap-6">
      @for (particularity of particularities; track particularity) {
        <div class="flex-1 basis-full md:basis-1/3 lg:basis-1/4">
          <app-info-card
            [prefixIconCustom]="particularity.icon"
            [title]="particularity.title"
            [description]="particularity.description"
            titleClassName="text-2xl text-medium text-center lg:text-start"
            containerClassName="h-full"
            [sectionClassName]="'w-full' + 'p-8 ' + particularity.bgColor + '-100 dark:' + particularity.bgColor + '-600'"
            descriptionClassName="text-base text-secondary-foreground"/>
        </div>
      }
    </div>
  </div>

  <div class="flex flex-col" id="faq">
    <app-section-header
      [title]="'Have questions about development?'"
      [description]="
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc vulputate libero et velit interdum, ac aliquet odio mattis. Class aptent taciti sociosqu ad litora torquent '
      "
      containerClassName="pt-0"
      className="max-w-[800px]"/>

    <div hlmAccordion class="flex flex-col items-center gap-6">
      @for (item of faq; track item; let i = $index) {
        <div hlmAccordionItem class="max-w-[800px] border-none">
          <button hlmAccordionTrigger class="group rounded-3xl bg-gray-100 p-6 hover:no-underline">
            <h2 class="text-base font-medium">{{ i + 1 + '. ' + item.question }}</h2>
            <lucide-icon
              name="chevron-down"
              size="24"
              class="text-foreground transition-transform duration-300 group-data-[state=open]:rotate-90"/>
          </button>
          <hlm-accordion-content class="rounded-3xl bg-gray-100">
            <div class="p-6">
              <ul class="flex list-disc flex-col gap-4 pl-4">
                @for (answer of item.answers; track answer) {
                  <li class="text-sm">
                    {{ answer }}
                  </li>
                }
              </ul>
            </div>
          </hlm-accordion-content>
        </div>
      }
    </div>
  </div>
</section>
